import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { RoutesConst } from '@carm/shared/constants/const-routes';
import { AuthService, UserToken } from '@carm/_auth/spartacus/core/auth';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AccessControlService } from '../access-control-mgt/services/access-control.service';
import { CarmRouter } from '../carm-router/services/carm-router.service';

@Injectable()
export class AuthGuard  {

  constructor(
    protected authService: AuthService,
    protected accessControlService: AccessControlService,
    protected router: CarmRouter,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      return this.isUserTokenExist();
  }

  /**
   * Determines whether user token exist, if not then redirect to login page
   * @returns user token exist
   */
  isUserTokenExist(): Observable<boolean> {
    return this.authService.getUserToken().pipe(
      map((token: UserToken) => {
        if (!token.access_token) {
          this.router.carmNavigate([RoutesConst.Login]);
          return false;
        } else {
          return !!token.access_token;
        }
      }), take(1));
  }

}
